module.exports = __webpack_public_path__ + "static/media/corporate-master.474667ad.xls";